import { validatePhone } from '../../../../../util/form-validation';
import { convertValidationRules } from '../../../../../hooks/useFormState';

export type Model = {
  callbackPhoneNumber: string;
  receiveCallBack: boolean;
};

export default convertValidationRules<Model>(context => {
  const { receiveCallBack } = context.values;
  return {
    callbackPhoneNumber: receiveCallBack ? validatePhone : null,
  };
});
